import { render } from "./ValueFormattingFields.vue?vue&type=template&id=01ad6770&scoped=true"
import script from "./ValueFormattingFields.vue?vue&type=script&lang=js"
export * from "./ValueFormattingFields.vue?vue&type=script&lang=js"

import "./ValueFormattingFields.vue?vue&type=style&index=0&id=01ad6770&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ad6770"]])

export default __exports__